import React from 'react';
import { DEFAULT_HIGHLIGHT_COLOR, MIN_COLS, MAX_COLS, COLS_TO_SKIP, INIT_COL_CLASS } from '../consts';
import { cn, getColorway, getCustomBackgroundColor } from 'utils/styles';
import styles from '../RichTextTable.module.css';
import { Node } from '@contentful/rich-text-types';
import type { Color } from 'libs/contentful/types';
import { TableChild } from '../types';

export const renderTableRow = (
  _node: Node,
  children: React.ReactNode,
  highlightedColumnIndex: number,
  highlightColor: Color | undefined,
  sectionColorway: string,
) => {
  const tableChildren = React.Children.toArray(children) as TableChild[];
  const cells = tableChildren.filter(c => c.type === 'td' || c.type === 'th');
  const cellCount = cells.length;
  const lessThanMax = cellCount < MAX_COLS;
  const isMin = cellCount == MIN_COLS;
  const className = cn(lessThanMax ? styles.firstCol50 : styles.firstCol33, isMin && styles.lastColHidden);

  const highlightColorwayClass = getColorway(highlightColor ?? DEFAULT_HIGHLIGHT_COLOR);
  const customBg = highlightColor && getCustomBackgroundColor(highlightColor);

  return (
    <tr className={className}>
      {/*
        Set a data-column property on each cell within the row
        Add classes to be used in switchColumn() :
          colHidden - if compare column should be hidden on mobile
          init      - if compare column should be initially displayed on mobile
      */}
      {tableChildren.map((child, i) => {
        if (child.type === 'td' || child.type === 'th') {
          const isHighlighted = i === highlightedColumnIndex;

          return React.cloneElement(child, {
            'data-column': i,
            ...(isHighlighted && { 'data-highlighted': 'true' }),
            className: cn(
              i > COLS_TO_SKIP ? styles.colHidden : isHighlighted && INIT_COL_CLASS,
              styles.cell,
              isHighlighted ? !customBg && highlightColorwayClass : i > 0 && sectionColorway,
            ),
          });
        }
        return child;
      })}
      {/* If row has minimum cells, add an empty td for layout */}
      {isMin && <td aria-hidden className={styles.cell}></td>}
    </tr>
  );
};
